<template>
  <div class="not-found">
    <div class="msg-box">
      <h1 class="animated fadeInDown">403 Access Denied</h1>
      <h2 class="animated fadeInUp">
        Oops!<br />It seems that you do not have permission to view this page
      </h2>
    </div>
  </div>
</template>

<script>
export default {
  name: "AccessDenied"
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/_variables";
@import "../../assets/scss/_mixins";

.msg-box {
  max-width: 320px;
  margin: 50px auto;

  h1 {
    @include text-bordered-shadow();
  }
}
</style>
